module.exports = __webpack_public_path__ + "static/media/PLANTA.66b6b8a5.png";